export default __webpack_public_path__ + "static/media/gaurav5.a3413fdc.jpeg";